import { jsx as o, jsxs as l, Fragment as p } from "react/jsx-runtime";
import { ChevronRight as h, ChevronLeft as x } from "@campoint/odi-ui-icons";
import { Menu as w, MenuItem as d, Flex as b, Spacer as g, Icon as s, SlideFade as a, MenuDivider as D, Text as v, MenuButton as C, MenuList as M, Box as k, Stack as _ } from "@chakra-ui/react";
import { createContext as S } from "@chakra-ui/react-utils";
import { useMultiStyleConfig as y, StylesProvider as I, chakra as u, forwardRef as m } from "@chakra-ui/system";
import { __DEV__ as N, cx as f } from "@chakra-ui/utils";
import { useDropdown as z } from "./use-dropdown.mjs";
const [B, c] = S({
  strict: !0,
  name: "DropdownContext",
  errorMessage: "useDropdownContext: `context` is undefined. Seems you forgot to wrap dropdown components in `<Dropdown />`"
}), L = ({ children: n, ...e }) => {
  const r = y("Dropdown", e), t = {
    ...z(e)
  };
  return /* @__PURE__ */ o(B, { value: t, children: /* @__PURE__ */ o(I, { value: r, children: /* @__PURE__ */ o(w, { ...e, children: n }) }) });
};
N && (L.displayName = "Dropdown");
const H = ({
  children: n,
  openSubMenu: e = null,
  highlighted: r = !1,
  ...i
}) => {
  const { setActiveMenu: t } = c();
  return /* @__PURE__ */ o(
    d,
    {
      onClick: () => {
        e && t(e);
      },
      p: "4",
      transitionDuration: "fast",
      backgroundColor: r ? "indigo.200" : "",
      _hover: {
        backgroundColor: r ? "indigo.300" : "gray.100",
        cursor: "pointer"
      },
      ...i,
      children: e ? (
        // chevron for submenus
        /* @__PURE__ */ l(b, { w: "full", alignItems: "center", fontSize: "md", children: [
          n,
          /* @__PURE__ */ o(g, {}),
          /* @__PURE__ */ o(s, { as: h, boxSize: "icon.md" })
        ] })
      ) : /* @__PURE__ */ o(p, { children: n })
    }
  );
}, T = (n) => {
  const { setActiveMenu: e, activeMenu: r } = c();
  return /* @__PURE__ */ o(a, { in: !0, children: /* @__PURE__ */ l(u.div, { display: "flex", flexDir: "column", gap: "2", children: [
    /* @__PURE__ */ l(
      d,
      {
        w: "full",
        alignItems: "center",
        onClick: () => e(null),
        fontSize: "md",
        color: "indigo.500",
        transitionDuration: "fast",
        fontWeight: "medium",
        px: 4,
        py: 2,
        children: [
          /* @__PURE__ */ o(s, { as: x, boxSize: "icon.md", mr: "2" }),
          n.children
        ]
      }
    ),
    /* @__PURE__ */ o(D, { my: 0, borderColor: "blackAlpha.200" }),
    /* @__PURE__ */ o(v, { fontWeight: "bold", fontSize: "2xl", lineHeight: "8", p: 4, children: r })
  ] }) });
}, V = ({
  subMenuName: n = null,
  children: e
}) => {
  const { activeMenu: r } = c();
  return r === n ? /* @__PURE__ */ o(a, { in: !0, children: /* @__PURE__ */ o(u.div, { children: e }) }) : null;
}, q = m(
  (n, e) => {
    const { className: r, ...i } = n, t = f("odi-dropdown__menubutton", r);
    return /* @__PURE__ */ o(
      C,
      {
        ref: e,
        ...i,
        minW: "100px",
        border: "none",
        borderRadius: "none",
        px: 15,
        py: 0,
        alignItems: "center",
        _hover: { color: "black", backgroundColor: "white" },
        _active: {
          color: "black",
          backgroundColor: "white"
        },
        css: { span: { alignItems: "center", display: "flex" } },
        className: t,
        children: n.children
      }
    );
  }
), G = m((n, e) => {
  const { className: r, ...i } = n, t = f("odi-dropdown__menulist", r);
  return /* @__PURE__ */ o(
    M,
    {
      rootProps: { width: ["full", "300px"] },
      ref: e,
      ...i,
      boxShadow: "none",
      borderRadius: 0,
      color: "black",
      minW: ["full", "300"],
      w: ["full", "300"],
      border: 0,
      className: t,
      pb: 0,
      children: /* @__PURE__ */ o(k, { boxShadow: "xl", border: "1", children: /* @__PURE__ */ o(_, { direction: "column", w: "full", gap: 0, children: n.children }) })
    }
  );
});
export {
  T as DMenuBackButton,
  q as DMenuButton,
  H as DMenuItem,
  G as DMenuList,
  V as DMenuSubList,
  L as Dropdown,
  c as useDropdownContext
};
